import { render } from "./LinkCustomerToDepotDiscountGroupModal.html?vue&type=template&id=09560742&scoped=true"
import script from "./LinkCustomerToDepotDiscountGroupModal.js?vue&type=script&lang=js"
export * from "./LinkCustomerToDepotDiscountGroupModal.js?vue&type=script&lang=js"

import "./LinkCustomerToDepotDiscountGroupModal.css?vue&type=style&index=0&id=09560742&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09560742"]])

export default __exports__